enum Sections {
  networkAndUsage = 'networkAndUsage',
  switching = 'switching',
}

enum Topics {
  networkCoverage = 'networkCoverage',
  uwSimWorksWithMobile = 'uwSimWorksWithMobile',
  phoneWorkAbroad = 'phoneWorkAbroad',
  overMonthlyAllowanceUsed = 'overMonthlyAllowanceUsed',
  unlimitedMeaning = 'unlimitedMeaning',
  support = 'support',
  uwTariffsAndTerms = 'uwTariffsAndTerms',
  canKeepNumber = 'canKeepNumber',
  contactToCurrentProvider = 'contactToCurrentProvider',
  stuckWithCurrentProvider = 'stuckWithCurrentProvider',
  whenSimDelivered = 'whenSimDelivered',
}

export { Topics, Sections };
